export default "__VITE_ASSET__BeQEChLf__"